(ns dre.components.widget.views.content-footer
  (:require
   [dre.i18n.views :refer [tr]]
   [dre.utils.bem :as bem]
   [re-frame.core :as rf]
   [dre.components.tree :refer [tree]]))

(def component-name :widget-content-footer)

(defn view
  [content]
  [:div
   {:class component-name}
   content])